import { Injectable } from '@angular/core';
import { of, Observable, throwError, BehaviorSubject } from 'rxjs';
import { Router } from '@angular/router';
import { DataService } from '@data/service/data.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private currentUserSubject!: BehaviorSubject<any>;
  public currentUser!: Observable<any>;
  private currentUserAccessSubject!: BehaviorSubject<any>;
  public currentUserAccess!: Observable<any>;
  private currentUserCheckInSubject!: BehaviorSubject<any>;
  public currentUserCheckIn!: Observable<any>;

  constructor(private _router: Router, public dataService: DataService) { }

  public get currentUserAccessValue(): any {
    return this.currentUserAccessSubject.value;
  }

  public get currentUserCheckInValue(): any {
    return this.currentUserCheckInSubject.value;
  }

  public get currentUserValue(): any {
    return this.currentUserSubject.value;
  }

  public SetCurrentUser(user: any) {
    this.currentUserSubject.next(user);
  }

  public SetCurrentUserAccess(user: any) {
    this.currentUserAccessSubject.next(user);
  }

  public SetUserCheckIn(checkIn: any) {
    this.currentUserCheckInSubject.next(checkIn);
  }

  login() {
    if (window.location.host == "localhost:4200") {
      window.localStorage.clear();
    }
  }

  logout() {
    localStorage.removeItem('currentUser');
    this.currentUserSubject.next(null);
    this._router.navigate(['/']);
  }

  isLogin() {
    const isLogin = JSON.parse(localStorage.getItem('isLoggin')!);
    if ((isLogin == null || !isLogin) && (localStorage.getItem('system') != "POINT" || localStorage.getItem('system') == null)) {
      localStorage.setItem('isLoggin', "false")
      localStorage.removeItem('system');
      localStorage.removeItem('currentUser');

      return false
    }
    return true;
  }

  getUserRole(): string | null {
    const claim = localStorage.getItem('userClaim');
    if (!claim) return null;

    try {
      const parsed = JSON.parse(claim);
      return parsed.Role || null;
    } catch (e) {
      return null;
    }
  }

  getUserId(): string | null {
    const claim = localStorage.getItem('userClaim');
    if (!claim) return null;

    try {
      const parsed = JSON.parse(claim);
      return parsed.UserId || null;
    } catch (e) {
      return null;
    }
  }
}